// Business logic: Reusable card component for account overview page displaying different types of account-related actions like voting, questionnaires, and membership status.
import { Button } from "@/components/ui/button";
import Link from "next/link";

interface AccountCardProps {
  theme: "light" | "dark";
  title: string;
  description: string[];
  buttonText?: string;
  href?: string;
}

export const AccountCard = ({ theme, title, description, buttonText, href }: AccountCardProps) => {
  const isDark = theme === "dark";

  return (
    <div
      className={` ${isDark ? "bg-nsc-dark-blue" : "bg-gray-100"} flex min-h-[300px] flex-col justify-between rounded-lg p-8 md:min-h-[320px] md:p-10`}
    >
      <div>
        <h2
          className={`mb-4 hyphens-auto text-wrap break-words font-oswald text-3xl uppercase !leading-[40px] md:mb-6 md:text-4xl md:!leading-[50px] ${isDark ? "text-white" : "text-nsc-dark-blue"} `}
        >
          {title}
        </h2>
        <div className="mb-6 space-y-3 md:mb-8">
          {description.map((text, index) => (
            <p
              key={index}
              className={` ${isDark ? "text-white" : "text-nsc-dark-blue"} text-sm leading-relaxed md:text-base`}
            >
              {text}
            </p>
          ))}
        </div>
      </div>
      {buttonText && href && (
        <Link href={href} className="w-full">
          <Button variant="default" size="lg" className="w-full py-4 font-oswald text-lg uppercase md:text-xl">
            {buttonText}
          </Button>
        </Link>
      )}
    </div>
  );
}; 